export default __webpack_public_path__ + "static/media/kit.da928b09.svg";